import React from 'react';

const toneCls = {
  blue: '',
  cyan: 'nx-chip--cyan',
  amber: 'nx-chip--amber',
  lime: 'nx-chip--lime',
  red: 'nx-chip--red',
  'solid-red': 'nx-chip--solid-red',
  'solid-amber': 'nx-chip--solid-amber',
  'solid-lime': 'nx-chip--solid-lime',
};

export function NxChip({ tone = 'blue', children, className = '', ...rest }) {
  const base = tone === 'blue' ? 'nx-chip--blue' : (toneCls[tone] || '');
  return (
    <span className={`nx-chip ${base} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}
